export enum BranchesEnum {
    CA7CommAuto = 'Automotor',
    CA7_Car = 'Automotor',
    CA7_Motorcycle = 'Moto',
    CA7_License = 'Licencia de Conductor',
    CA7_Agency = 'Agencia de Vehículos',
    CA7_Garage = 'Garage / Taller',

    Fire = 'Incendio',
    AllRisk = 'Todo Riesgo Operativo',
    OtherRisk = 'Otros Riesgos',
    CP7_OtherRisk = 'Riesgos Varios',
    CP7_OtherRiskGlass = 'Cristales',

    Theft = 'Robo',
    CP7_TheftHome = 'Robo',
    CP7_TheftComercialActivity = 'Robo',
    CP7_TheftEmployeeLoyalty = 'Robo',
    CP7_TheftSecurities = 'Robo',
    CP7_TheftBankIntegral = 'Robo',
    CP7_TheftAllRisk = 'Robo',

    PersonalAccidents = 'Accidentes personales',
    AAH_PersAccIndividual = 'AP Individual',
    AAH_PersAccCollective = 'AP Colectivo',

    Combined = 'Combinado',
    CP7_CombinedCombinedFamily = 'Hogar',
    CP7_CombinedConsortium = 'Consorcio',
    CP7_CombinedIntegralTrade = 'Integral de Comercio',

    GeneralLiability_GLE = 'Responsabilidad Civil',
    InlandMarine = 'Transporte',
    HullAndAircraft = 'Embarcaciones',

    Agriculture = 'Riesgos Agropecuarios',
    CP7_AgriculturalRisksAgroHail = 'Granizo',
    CP7_AgriculturalRisksMultiRisk = 'Multiriesgo',
    CP7_AgriculturalRisksParametric = 'Paramétricos',
    CP7_AgriculturalRisksLivestock = 'Pecuario',

    Caution = 'Caución',

    IndividualLife = 'Vida Individual',
    AAH_IndividualLife = 'Vida Individual',

    CollectiveLife = 'Vida Colectivo',
    AAH_CollectiveTraditional = 'Vida Colectivo Tradicional',
    AAH_CollectiveDebitBalance = 'Saldo Deudor',
    AAH_CollectiveMandatoryLife1567 = 'Vida Colectivo Obligatorio',

    Technical = 'Seguro Técnico',


}
